import React, { useState, useEffect, FC } from "react";
import Content from "../../layout/content/Content";
import { Card, Row, Col, Button, Spinner } from "reactstrap";
import {
  TableColumnsType,
  Table,
  Progress,
  Select,
  Input,
  Flex,
  Spin,
  Empty,
  Tooltip,
  Drawer,
  Modal,
  Form,
  InputNumber,
  Space,
  Tag,
  Alert,
  Descriptions,
  Divider,
  DatePicker,
  Button as AntButton,
} from "antd";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  TooltipComponent,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import { 
  SearchOutlined, 
  InfoCircleOutlined, 
  PlayCircleOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  DollarOutlined,
  CalendarOutlined,
  ReloadOutlined,
  EyeOutlined 
} from "@ant-design/icons";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import statusMapper from "./StatusMapper";
import dispatchApis from "../../api/dispatch/dispatch";
import PaymentsAside from "./PaymentsAside";
import paymentApis from "../../api/payments/payments";
import { formatCurrency, formatCurrency2 } from "../../utils/Utils";
import usersApis from "../../api/master/users";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import dayjs from "dayjs";
import {
  PaymentData,
  PaymentStatus,
  PaymentMethod,
  PaymentFilters,
} from "./types";
import {
  mockPaymentData,
  getPaymentsByStatus,
  mockPaymentMethodOptions,
} from "./mockData/paymentData";
import {
  mockContractorOptions,
  mockSiteOptions,
} from "./mockData/approvedRaBillsData";
const { Option } = Select;
interface WidgetData {
  title: string;
  count: number;
  progress: number;
  color: string;
}

const RunPayments: FC = () => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [selectedCnKeys, setSelectedCnKeys] = useState<React.Key[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [widgetData, setWidgetData] = useState<WidgetData[]>([
    {
      title: "Ready to Run",
      count: 0,
      progress: 0,
      color: "#28A745",
    },
    {
      title: "In Progress",
      count: 0,
      progress: 0,
      color: "#FFC107",
    },
    {
      title: "Completed",
      count: 0,
      progress: 0,
      color: "#17A2B8",
    },
    {
      title: "Failed",
      count: 0,
      progress: 0,
      color: "#DC3545",
    },
  ]);
  const [sm, setSm] = useState(false);
  const navigate = useNavigate();
  const [CNError, setCNError] = useState<any>(null);
  const [selectedCNValueTotal, setSelectedCNValueTotal] = useState(0);
  const [selectedCNValueUtilized, setSelectedCNValueUtilized] = useState([]);
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [viewDrawer, setViewDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState<any>(null);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [approverIds, setApproverIds] = useState<any>([]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [paymentMode, setPaymentMode] = useState<string>("neft");
  const [editingCn, setEditingCn] = useState<any>([]);
  const [CN, setCN] = useState<any>([]);
  const [refreshToggle, setRefreshToggle] = useState(false);

  // Enhanced state for new payment run functionality
  const [loading, setLoading] = useState(false);
  const [approvedPayments, setApprovedPayments] = useState<PaymentData[]>([]);
  const [filteredPayments, setFilteredPayments] = useState<PaymentData[]>([]);
  const [selectedPayment, setSelectedPayment] = useState<PaymentData | null>(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedPaymentIds, setSelectedPaymentIds] = useState<React.Key[]>([]);
  const [runProgress, setRunProgress] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  // Filters
  const [filters, setFilters] = useState<PaymentFilters>({});
  const [searchText, setSearchText] = useState("");

  // Enhanced useEffect hooks for payment runs
  useEffect(() => {
    loadApprovedPayments();
  }, [refreshToggle]);

  useEffect(() => {
    applyFilters();
  }, [approvedPayments, filters, searchText]);

  const loadApprovedPayments = async () => {
    try {
      setLoading(true);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Get approved payments ready for run
      const approvedForRun = getPaymentsByStatus(PaymentStatus.Approved);
      setApprovedPayments(approvedForRun);
      
      // Update widget data
      setWidgetData([
        {
          title: "Ready to Run",
          count: approvedForRun.length,
          progress: 100,
          color: "#28A745",
        },
        {
          title: "In Progress",
          count: 0,
          progress: 0,
          color: "#FFC107",
        },
        {
          title: "Completed",
          count: getPaymentsByStatus(PaymentStatus.Paid).length,
          progress: 100,
          color: "#17A2B8",
        },
        {
          title: "Failed",
          count: 0,
          progress: 0,
          color: "#DC3545",
        },
      ]);
      
    } catch (error) {
      console.error("Error loading approved payments:", error);
      Swal.fire("Error!", "Failed to load approved payments", "error");
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...approvedPayments];

    // Apply search text filter
    if (searchText) {
      filtered = filtered.filter(payment =>
        payment.paymentVoucherNumber.toLowerCase().includes(searchText.toLowerCase()) ||
        payment.contractorName.toLowerCase().includes(searchText.toLowerCase()) ||
        payment.siteName.toLowerCase().includes(searchText.toLowerCase()) ||
        (payment.utrReference && payment.utrReference.toLowerCase().includes(searchText.toLowerCase())) ||
        payment.allocations.some(alloc =>
          alloc.raBillNumber?.toLowerCase().includes(searchText.toLowerCase()) ||
          alloc.workOrderNumber?.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    }

    // Apply contractor filter
    if (filters.contractorIds && filters.contractorIds.length > 0) {
      filtered = filtered.filter(payment => filters.contractorIds!.includes(payment.contractorId));
    }

    // Apply site filter
    if (filters.siteIds && filters.siteIds.length > 0) {
      filtered = filtered.filter(payment => filters.siteIds!.includes(payment.siteId));
    }

    // Apply payment method filter
    if (filters.paymentMethods && filters.paymentMethods.length > 0) {
      filtered = filtered.filter(payment => filters.paymentMethods!.includes(payment.paymentMethod));
    }

    setFilteredPayments(filtered);
  };

  const getStatusColor = (status: PaymentStatus): string => {
    const colors: Partial<Record<PaymentStatus, string>> = {
      [PaymentStatus.Approved]: "success",
      [PaymentStatus.Posted]: "cyan",
      [PaymentStatus.Paid]: "green",
    };
    return colors[status] || "default";
  };

  const handleViewPayment = (payment: PaymentData) => {
    setSelectedPayment(payment);
    setShowDetailsModal(true);
  };

  const handleRunSelectedPayments = async () => {
    if (selectedPaymentIds.length === 0) {
      Swal.fire("Warning", "Please select payments to run", "warning");
      return;
    }

    try {
      setIsRunning(true);
      setRunProgress(0);

      // Simulate payment run progress
      for (let i = 0; i <= 100; i += 10) {
        setRunProgress(i);
        await new Promise(resolve => setTimeout(resolve, 200));
      }

      // Update payment statuses to Posted
      const updatedPayments = approvedPayments.map(payment => {
        if (selectedPaymentIds.includes(payment.id)) {
          return {
            ...payment,
            status: PaymentStatus.Posted,
            postedAt: dayjs().toISOString(),
            postedBy: "finance.user@company.com",
            utrReference: `${payment.paymentMethod}${dayjs().format("MMDD")}${Math.floor(Math.random() * 10000)}`,
            approvalHistory: [
              ...payment.approvalHistory,
              {
                action: "Payment Run",
                actionBy: "finance.user@company.com",
                actionDate: dayjs().toISOString(),
                role: "Finance" as any,
                comments: "Payment processed successfully",
                status: PaymentStatus.Posted,
              },
            ],
          };
        }
        return payment;
      });

      setApprovedPayments(updatedPayments.filter(p => !selectedPaymentIds.includes(p.id)));
      setSelectedPaymentIds([]);

      Swal.fire(
        "Success!",
        `${selectedPaymentIds.length} payments have been processed successfully`,
        "success"
      );

    } catch (error) {
      console.error("Error running payments:", error);
      Swal.fire("Error!", "Failed to run payments", "error");
    } finally {
      setIsRunning(false);
      setRunProgress(0);
    }
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedPaymentIds(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys: selectedPaymentIds,
    onChange: onSelectChange,
  };

  // Enhanced columns for payment runs
  const enhancedColumns: any = [
    {
      title: "#",
      key: "#",
      width: 50,
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Payment Voucher",
      dataIndex: "paymentVoucherNumber",
      key: "paymentVoucherNumber",
      width: 160,
      fixed: "left",
      render: (text: string, record: PaymentData) => (
        <div>
          <div className="fw-bold text-primary">{text}</div>
          <small className="text-muted">{dayjs(record.approvedAt).format("DD/MM/YYYY")}</small>
        </div>
      ),
    },
    {
      title: "Contractor",
      key: "contractor",
      width: 200,
      render: (record: PaymentData) => (
        <div>
          <div className="fw-bold">{record.contractorName}</div>
          <small className="text-muted">{record.siteName}</small>
        </div>
      ),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
      width: 120,
      render: (method: PaymentMethod) => (
        <Tag color="blue">{method}</Tag>
      ),
    },
    {
      title: "Bank Account",
      dataIndex: "bankAccountName",
      key: "bankAccountName",
      width: 140,
    },
    {
      title: "Net Amount",
      dataIndex: "netPayable",
      key: "netPayable",
      width: 140,
      render: (amount: number) => (
        <div className="fw-bold text-success">₹{amount?.toLocaleString()}</div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status: PaymentStatus) => (
        <Tag color={getStatusColor(status)}>{status}</Tag>
      ),
    },
    {
      title: "RA Bills",
      key: "raBills",
      width: 80,
      render: (record: PaymentData) => (
        <span className="badge badge-dim badge-blue">
          {record.allocations.length}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 80,
      fixed: "right",
      render: (record: PaymentData) => (
        <Space>
          <Tooltip title="View Details">
            <AntButton
              type="text"
              icon={<EyeOutlined />}
              onClick={() => handleViewPayment(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const isCnEditing = (record: any) => editingCn.includes(record.noteNumber);

  // Keep original columns for existing functionality
  const columns: any = [
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Payment #",
      dataIndex: "paymentId",
      key: "PaymentId",
      width: 200,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 150,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`supplierName-tooltip-${index}`}>
              {text?.length > 20 ? `${text?.substring(0, 25)}... ` : text}
            </span>
            {text?.length > 20 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`supplierName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Payable Amount",
      dataIndex: "payableAmount",
      key: "payableAmount",
      width: 140,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(Number(text), "INR")}
              {/* <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      width: 120,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.buyer;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 70,
      render: (text: any, record: any) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              setViewDrawer(true);
              fetchPaymentDetails(record?.paymentNumber);
            }}
          >
            <Icon name="focus" />
          </Button>
        </>
      ),
    },
  ];

  const fetchPaymentDetails = async (paymentNumber: any) => {
    try {
      const res = await paymentApis.fetchPayment(paymentNumber);
      const { data, status, message } = res;
      if (status) {
        setDrawerData(data);
        fetchAllOrgUnUtilizedCreditDebitNotes(
          data?.paymentLines[0]?.supplierId
        );
        setApproverIds(
          data?.paymentApprovals
            ?.filter((item: any) => item?.status == "Pending")
            ?.map((item: any) => item?.userId)
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {}
  };

  const drawerColumns: any = [
    // {
    //   title: "#",
    //   key: "#",
    //   width: 50,
    //   fixed: "left",
    //   render: (text: any, record: any, index: any) => index + 1,
    // },
    {
      title: "Invoice #",
      dataIndex: "invoiceId",
      key: "invoiceId",
      width: 200,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 150,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 200,
    },
    {
      title: "Payable Amount",
      dataIndex: "payableAmount",
      key: "payableAmount",
      width: 140,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(Number(text), "INR")}
              {/* <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
  ];
  const cNColumns: any = [
    {
      title: "Note #",
      dataIndex: "noteId",
      key: "noteId",
      width: 100,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Note Amount",
      key: "unUtilizedAmount",
      width: 140,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(Number(record?.unUtilizedAmount), "INR")}
              {/* <Tooltip
              title={formatCurrency(Number(record?.unUtilizedAmount), "INR")}
            >
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "utilizedAmount",
      key: "utilizedAmount",
      width: 200,
      editable: true,
      render: (text: any, record: any) => {
        return <span></span>;
      },
    },
  ];
  const onCNSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedCnKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      editingCn.forEach((key: any) => {
        const row = CN.find((item: any) => item.noteNumber == key);
        form3.setFieldsValue({
          [`utilizedAmount_${row.noteNumber}`]:
            Number(row?.noteAmount) - Number(row?.utilizedAmount),
        });
      });
      setEditingCn(() => []);
      form3.resetFields();
    }
    const unSelectedRowKeys = selectedCnKeys.filter(
      (key) => !newSelectedRowKeys.includes(key)
    );
    unSelectedRowKeys?.forEach((key) => {
      const row = CN.find((item: any) => item.noteNumber == key);
      form3.setFieldsValue({
        [`utilizedAmount_${row.noteNumber}`]:
          Number(row?.noteAmount) - Number(row?.utilizedAmount),
      });
    });
    const editableRowKeys: any = [];
    newSelectedRowKeys?.forEach((key) => {
      const row = CN.find((item: any) => item.noteNumber == key);
      if (row) {
        form3.setFieldsValue({ ...row });
        editableRowKeys.push(row.noteNumber);
      }
    });
    setEditingCn(editableRowKeys);
  };
  const cnRowSelection = {
    selectedRowKeys: selectedCnKeys,
    onChange: onCNSelectChange,
  };

  const fetchAllOrgUnUtilizedCreditDebitNotes = async (supplierId: any) => {
    try {
      const res = await paymentApis.fetchAllOrgUnUtilizedCreditDebitNotes(
        supplierId
      );
      const { data, status, message } = res;
      if (status) {
        setCN(data);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCurrentUser = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        setCurrentUserId(data?.id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const runPayment = async (_data: any) => {
    try {
      const res = await paymentApis.runPayment({
        paymentData: {
          paymentNumber: _data.paymentNumber,
          paymentMode: _data?.paymentMode,
          transactionNumber: _data?.transactionNumber?.toString(),
          creditDebitNotes: selectedCNValueUtilized,
        },
      });
      const { data, status, message } = res;
      if (status) {
        Swal.fire("Success", message, "success");
        setViewDrawer(false);
        setDrawerData(null);
        setRefreshToggle(!refreshToggle);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableSubmit(false);
  };

  const EditCN = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }: any) => {
    const handleBlur = (value: number) => {
      console.log("blur", value);
      form3.submit();
    };

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={`utilizedAmount_${record.noteNumber}`}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `${title} is required`,
              },
              {
                type: "number",
                min: 0.01,
                message: `${title} must > 0`,
              },
              {
                type: "number",
                max: Number(record?.unUtilizedAmount),
                message: `${title} must <= ${formatCurrency(
                  Number(record?.unUtilizedAmount),
                  "INR"
                )}`,
              },
            ]}
            initialValue={Number(record?.unUtilizedAmount)}
          >
            <InputNumber
              className="w-100"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
              onKeyPress={(event) => {
                const regex = /^[0-9\b\.]+$/;
                if (!regex.test(event.key)) {
                  event.preventDefault();
                }
              }}
              step={0.01}
              onBlur={(e: any) => handleBlur(e?.target?.value)} // Use onBlur instead of onChange
            />
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const { Search } = Input;
  const { Option } = Select;

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey="run-payments"
        title="Run Payments"
        columns={enhancedColumns}
        dataSource={filteredPayments}
        loading={loading}
        rowSelection={rowSelection}
        sideNavigation={
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
              sm ? "content-active" : ""
            }`}
          >
            <PaymentsAside updateSm={setSm} sm={sm} />
          </div>
        }
        refresh={refreshToggle}
        extra={{
          tableScrollX: 1200,
          customFilters: (
            <div className="mb-3">
              <Row gutter={[16, 16]}>
                <Col span={5}>
                  <Search
                    placeholder="Search approved payments..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    allowClear
                  />
                </Col>
                <Col span={5}>
                  <Select
                    placeholder="Filter by Contractor"
                    value={filters.contractorIds}
                    onChange={(value) => setFilters({...filters, contractorIds: value})}
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                  >
                    {mockContractorOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={5}>
                  <Select
                    placeholder="Payment Method"
                    value={filters.paymentMethods}
                    onChange={(value) => setFilters({...filters, paymentMethods: value})}
                    mode="multiple"
                    allowClear
                    style={{ width: "100%" }}
                  >
                    {mockPaymentMethodOptions.map(option => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={4}>
                  <AntButton
                    icon={<ReloadOutlined />}
                    onClick={loadApprovedPayments}
                    loading={loading}
                  >
                    Refresh
                  </AntButton>
                </Col>
                <Col span={5}>
                  <AntButton
                    type="primary"
                    icon={<PlayCircleOutlined />}
                    onClick={handleRunSelectedPayments}
                    disabled={selectedPaymentIds.length === 0 || isRunning}
                    loading={isRunning}
                    size="large"
                  >
                    {isRunning ? `Running ${runProgress}%` : `Run Payments (${selectedPaymentIds.length})`}
                  </AntButton>
                </Col>
              </Row>
              
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div>
                  <Tag color="blue">
                    <CheckCircleOutlined /> {filteredPayments.length} approved payments ready
                  </Tag>
                  <Tag color="green">
                    <DollarOutlined /> Total Value: ₹{filteredPayments.reduce((sum, p) => sum + p.netPayable, 0).toLocaleString()}
                  </Tag>
                  {selectedPaymentIds.length > 0 && (
                    <Tag color="orange">
                      Selected: {selectedPaymentIds.length} payments (₹{filteredPayments.filter(p => selectedPaymentIds.includes(p.id)).reduce((sum, p) => sum + p.netPayable, 0).toLocaleString()})
                    </Tag>
                  )}
                </div>
              </div>

              {isRunning && (
                <div className="mt-3">
                  <Alert
                    message="Payment Run in Progress"
                    description={`Processing ${selectedPaymentIds.length} payments... Please wait.`}
                    type="info"
                    showIcon
                  />
                  <Progress percent={runProgress} status="active" className="mt-2" />
                </div>
              )}
            </div>
          ),
        }}
        widget={{
          isActive: true,
          list: widgetData.map(widget => ({
            title: widget.title,
            value: widget.count.toString(),
            percentage: widget.progress.toString(),
            color: widget.color,
          })),
        }}
      />

      {/* Enhanced Payment Details Modal */}
      <Modal
        title={
          <div className="d-flex align-items-center">
            <PlayCircleOutlined className="mr-2" />
            Payment Run Details - {selectedPayment?.paymentVoucherNumber}
          </div>
        }
        open={showDetailsModal}
        onCancel={() => setShowDetailsModal(false)}
        width={1000}
        footer={[
          <AntButton key="close" onClick={() => setShowDetailsModal(false)}>
            Close
          </AntButton>,
        ]}
      >
        {selectedPayment && (
          <div>
            <Row gutter={[24, 16]}>
              <Col span={16}>
                <Descriptions bordered size="small" column={2}>
                  <Descriptions.Item label="Payment Voucher">
                    {selectedPayment.paymentVoucherNumber}
                  </Descriptions.Item>
                  <Descriptions.Item label="Approved Date">
                    {dayjs(selectedPayment.approvedAt).format("DD/MM/YYYY")}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contractor">
                    {selectedPayment.contractorName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Site">
                    {selectedPayment.siteName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Payment Method">
                    <Tag color="blue">{selectedPayment.paymentMethod}</Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Bank Account">
                    {selectedPayment.bankAccountName}
                  </Descriptions.Item>
                  <Descriptions.Item label="Net Payable" span={2}>
                    <strong className="text-success">₹{selectedPayment.netPayable.toLocaleString()}</strong>
                  </Descriptions.Item>
                </Descriptions>
              </Col>
              <Col span={8}>
                <Alert
                  message="Ready for Payment Run"
                  description={
                    <div>
                      <p>This payment has been approved and is ready to be processed.</p>
                      <ul className="mb-0">
                        <li>All approvals completed</li>
                        <li>Bank details verified</li>
                        <li>TDS calculated</li>
                      </ul>
                    </div>
                  }
                  type="success"
                  showIcon
                />
              </Col>
            </Row>

            <Divider />

            <h6>Payment Allocations ({selectedPayment.allocations.length})</h6>
            <Table
              columns={[
                {
                  title: "RA Bill",
                  dataIndex: "raBillNumber", 
                  key: "raBillNumber",
                  width: 140,
                },
                {
                  title: "Work Order",
                  dataIndex: "workOrderNumber",
                  key: "workOrderNumber", 
                  width: 140,
                },
                {
                  title: "This Payment",
                  dataIndex: "thisPaymentAmount",
                  key: "thisPaymentAmount",
                  width: 120,
                  render: (amount: number) => `₹${amount?.toLocaleString()}`,
                },
                {
                  title: "Status",
                  dataIndex: "resultingStatus", 
                  key: "resultingStatus",
                  width: 100,
                  render: (status: string) => <Tag color="green">{status}</Tag>,
                },
              ]}
              dataSource={selectedPayment.allocations}
              rowKey="id"
              size="small"
              pagination={false}
            />
          </div>
        )}
      </Modal>
      <Drawer
        title={
          <div className="d-flex justify-content-between align-items-center">
            <strong>Run Payment</strong>
            <>
              <div style={{ textAlign: "right" }}>
                {disableSubmit ? (
                  <Button color="primary" type="button">
                    <Spinner size="sm" color="light" />
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      form2.submit();
                    }}
                    color="primary"
                    disabled={CNError ? true : false}
                    className="m-3 mt-0 mb-0"
                  >
                    Clear Payment
                  </Button>
                )}
              </div>
            </>
          </div>
        }
        placement="right"
        onClose={() => setViewDrawer(false)}
        open={viewDrawer}
        width="85vw"
        style={{
          position: "absolute",
          zIndex: 1100,
        }}
        styles={{ body: { paddingBottom: 80 } }}
      >
        {drawerData ? (
          <>
            <Form
              form={form2}
              layout="vertical"
              onFinish={(data) => {
                setDisableSubmit(true);
                Swal.fire({
                  title: "Are you sure?",
                  text: "You are about to Clear Payment",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes !",
                }).then((result) => {
                  if (result.isConfirmed) {
                    runPayment({
                      ...data,
                      paymentNumber: drawerData?.paymentNumber,
                    });
                  } else {
                    setDisableSubmit(false);
                  }
                });
              }}
              requiredMark={false}
            >
              <div className="d-flex justify-content-between p-3 pb-0 pt-0">
                <div>
                  <strong>Remark</strong>
                  <p>{drawerData?.remarks}</p>
                </div>
                <div>
                  <div className="w-100">
                    <div className="d-flex justify-content-between">
                      <div className="justify-end">
                        <strong>Payable Amount Total &nbsp; &nbsp; </strong>
                      </div>
                      <strong className="fw-bold">
                        {formatCurrency(
                          Number(drawerData?.payableAmount || 0),
                          drawerData?.currencyCode || "INR"
                        )}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive poTable">
                <div
                  style={{
                    width: screenSize - 300 + "px",
                    margin: "0px auto 15px auto",
                  }}
                >
                  <Table
                    className="customTable"
                    columns={drawerColumns}
                    dataSource={drawerData?.paymentLines}
                    scroll={{ x: 1000 }}
                    bordered
                    size="middle"
                    pagination={false}
                  />
                </div>
              </div>
              <div className="table-responsive poTable">
                <div
                  style={{
                    width: screenSize - 400 + "px",
                    margin: "0px auto 15px auto",
                  }}
                >
                  <Form
                    form={form3}
                    component={false}
                    onFinish={(data) => {
                      let selectedCNValueTotal = 0;
                      const _selectedCNValues: any = [];
                      Object.keys(data).map((key) => {
                        if (key.includes("utilizedAmount")) {
                          selectedCNValueTotal += Number(data[key]);
                          _selectedCNValues.push({
                            noteNumber: Number(key.split("_")[1]),
                            utilizedAmount: Number(data[key]),
                          });
                        }
                      });

                      setSelectedCNValueUtilized(_selectedCNValues);
                      if (selectedCNValueTotal > drawerData?.payableAmount) {
                        setCNError(
                          "Utilized Amount is greater than Payable Amount"
                        );
                      } else {
                        setCNError(null);
                      }
                      setSelectedCNValueTotal(selectedCNValueTotal);
                    }}
                  >
                    <Table
                      title={() => (
                        <div className="d-flex justify-content-between">
                          {CNError ? (
                            <strong style={{ color: "red" }}>{CNError}</strong>
                          ) : (
                            <strong>Select Credit Notes (if needed)</strong>
                          )}
                          {selectedCnKeys.length > 0 && (
                            <Button
                              color="primary"
                              className="m-0"
                              style={{ height: "30px" }}
                              onClick={() => {
                                form3.submit();
                              }}
                            >
                              Use
                            </Button>
                          )}
                        </div>
                      )}
                      footer={() => (
                        <div className="w-25" style={{ marginLeft: "auto" }}>
                          <div className="d-flex justify-content-between">
                            <strong>Payable Amount</strong>
                            <strong>
                              {formatCurrency(drawerData?.payableAmount, "INR")}
                            </strong>
                          </div>
                          <div className="d-flex justify-content-between mt-2">
                            <strong>Credit Note Amount</strong>
                            <strong>
                              {formatCurrency(selectedCNValueTotal, "INR")}
                            </strong>
                          </div>
                          <div className="d-flex justify-content-between mt-2">
                            <strong>Remaining Amount</strong>
                            <strong>
                              {formatCurrency(
                                drawerData?.payableAmount -
                                  selectedCNValueTotal,
                                "INR"
                              )}
                            </strong>
                          </div>
                        </div>
                      )}
                      className="customTable"
                      rowSelection={cnRowSelection}
                      columns={cNColumns?.map((col: any) => {
                        if (!col.editable) {
                          return col;
                        }
                        return {
                          ...col,
                          onCell: (record: any) => ({
                            record,
                            inputType: "number",
                            dataIndex: col.dataIndex,
                            title: col.title,
                            editing: isCnEditing(record),
                          }),
                        };
                      })}
                      dataSource={CN?.map((field: any) => {
                        return {
                          ...field,
                          key: field.noteNumber,
                        };
                      })}
                      scroll={{ x: "max-content" }}
                      bordered
                      size="small"
                      pagination={false}
                      components={{
                        body: {
                          cell: EditCN,
                        },
                      }}
                    />
                  </Form>
                </div>
              </div>
              <div className="">
                <div className="tab-content mt-0 w-70 paddingLeft10 m-auto">
                  <div className="tab-content mt-0">
                    <Col className=" w-90  flex-wrap  p-0">
                      <>
                        <div className="w-100 p-1 pt-0 pb-0">
                          <div className="data-col p-0 pt-1">
                            <div className="data-label w-20">Payment Mode</div>
                            <div className="data-value w-80">
                              <Form.Item
                                name="paymentMode"
                                label={undefined}
                                className="w-100 paddingLeft10  p-0 m-0"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select payment mode",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select Invoice Type"
                                  onChange={(e) => {
                                    setPaymentMode(e);
                                  }}
                                >
                                  <Option value="neft">
                                    National Electronic Fund Transfer (NEFT)
                                  </Option>
                                  <Option value="rtgs">
                                    Real Time Gross Settlement (RTGS)
                                  </Option>
                                  <Option value="imps">
                                    Immediate Payment Services (IMPS)
                                  </Option>
                                  <Option value="cheque">CHEQUE</Option>
                                  <Option value="upi">UPI</Option>
                                  <Option value="cash">CASH</Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                        <div className="w-100 p-1 pt-0 pb-0">
                          {["neft", "rtgs", "imps"].includes(paymentMode) ? (
                            <div className="data-col p-0 pt-1">
                              <div className="data-label w-20">UTR</div>
                              <div className="data-value w-80">
                                <Form.Item
                                  name="transactionNumber"
                                  label={undefined}
                                  className="w-100 paddingLeft10 p-0 m-0"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter UTR",
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    placeholder="Enter UTR"
                                    className="w-100"
                                    formatter={(value) =>
                                      `${value}`.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ""
                                      )
                                    }
                                    parser={(value: any) =>
                                      value!.replace(/\$\s?|(,*)/g, "")
                                    }
                                    onKeyPress={(event) => {
                                      if (!/^[0-9]+$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          ) : ["upi"].includes(paymentMode) ? (
                            <div className="data-col p-0 pt-1">
                              <div className="data-label w-20">
                                Transaction ID
                              </div>
                              <div className="data-value w-80">
                                <Form.Item
                                  name="transactionNumber"
                                  label={undefined}
                                  className="w-100 paddingLeft10 p-0 m-0"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter Transaction ID",
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    placeholder="Enter Transaction ID"
                                    className="w-100"
                                    formatter={(value) =>
                                      `${value}`.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ""
                                      )
                                    }
                                    parser={(value: any) =>
                                      value!.replace(/\$\s?|(,*)/g, "")
                                    }
                                    onKeyPress={(event) => {
                                      if (!/^[0-9]+$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          ) : ["cheque"].includes(paymentMode) ? (
                            <div className="data-col p-0 pt-1">
                              <div className="data-label w-20">Cheque #</div>
                              <div className="data-value w-80">
                                <Form.Item
                                  name="transactionNumber"
                                  label={undefined}
                                  className="w-100 paddingLeft10 p-0 m-0"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter Cheque Number",
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    placeholder="Enter Cheque Number"
                                    className="w-100"
                                    formatter={(value) =>
                                      `${value}`.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ""
                                      )
                                    }
                                    parser={(value: any) =>
                                      value!.replace(/\$\s?|(,*)/g, "")
                                    }
                                    onKeyPress={(event) => {
                                      if (!/^[0-9]+$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </>
                    </Col>
                  </div>
                </div>
              </div>
            </Form>
          </>
        ) : (
          <>
            <Flex align="center" gap="middle" className="pageLoader">
              <Spin size="large" className="m-auto" />
            </Flex>
          </>
        )}
      </Drawer>
    </>
  );
};

export default RunPayments;
